import { Component, Input, OnInit } from "@angular/core";
import { SessionService } from "../../common/services/session.service";
import { ComplainStatusService } from "../../complain-chart/service/api/complain-status.service";

@Component({
  selector: "app-register-book-status-chart",
  templateUrl: "./register-book-status-chart.component.html",
  styleUrls: ["./register-book-status-chart.component.scss"],
})
export class RegisterBookStatusChartComponent implements OnInit {
  chartData: any;
  @Input()
  set registerStatusData(value) {
    this.chartData = value;
  }
  get registerStatusData() {
    return this.chartData;
  }

  officeData: any;
  RegisterStatus: any;
  options: any;
  constructor(private readonly session: SessionService) {
    this.options = {
      title: {
        display: false,
        text: "My Title",
        fontSize: 16,
      },
      legend: {
        position: "bottom",
        display: false,
      },
      cutoutPercentage: 80, //Here for innerRadius. It's already exists
      outerRadius: 100, //Here for outerRadius
    };
  }

  getComplaintStatus() {
    let temp = [];
    temp[0] = this.chartData;

    this.RegisterStatus = {
      labels: [],
      datasets: [
        {
          label: "Status",
          data: [],
          backgroundColor: [],
        },
      ],
    };

    temp[0].filter((ele) => {
      this.RegisterStatus.datasets[0].data.push(JSON.parse(ele.count));
      // this.RegisterStatus.datasets[0].data.sort((a, b) => {
      //   return a - b;
      // });
      this.RegisterStatus.labels.push(ele.status);
    });
    this.RegisterStatus.labels.map((ele)=>{
      switch(ele){
        case "HOLD":
        this.RegisterStatus.datasets[0].backgroundColor.push("rgba(163, 166, 180, 1)");
        break;

        case "SOLVED":
          this.RegisterStatus.datasets[0].backgroundColor.push("rgba(95, 227, 161, 1)");
          break;
        
        case "QUEUE":
          this.RegisterStatus.datasets[0].backgroundColor.push("rgba(255, 181, 69, 1)");
          break;
    
        case "UNSOLVED":
          this.RegisterStatus.datasets[0].backgroundColor.push("rgba(255, 131, 115, 1)");
          break;

        case "INPROGRESS":
          this.RegisterStatus.datasets[0].backgroundColor.push("rgba(86, 217, 254, 1)");
          break;
      }    
    })


    this.RegisterStatus["Total"] = this.RegisterStatus.datasets[0].data.reduce(
      (total, curr) => total + curr,
      0
    );
  }

  ngOnInit() {
    this.officeData = this.session.getOffice();
    this.getComplaintStatus();
  }
}
